const initialState = { policies_and_procedures: [] };

export const policies_and_procedures = (state = initialState, action) => {
  switch (action.type) {
    case "SET_POLICIES_AND_PROCEDURES":
      return { policies_and_procedures: action.payload };
  }
  return state;
};
